export const Area = Object.freeze({
    ACTIVE_STATUS: 'activeStatus',
    AREA_ID: 'areaId',
    AREA_DEFINITION: 'areaDefinition',
    EVENT_LEVEL_ENTER: 'eventLevelEnter',
    EVENT_LEVEL_INSIDE: 'eventLevelInside',
    EVENT_LEVEL_LEAVE: 'eventLevelLeave',
    EVENT_LEVEL_OUTSIDE: 'eventLevelOutside',
    GEO_FENCING_NOTIFICATION_TYPE: 'geofencingNotificationType',
    NAME: 'name',
    NUMBER: 'number',
    VALID_FROM: 'validFrom',
    VALID_TO: 'validTo',
    SCHEDULE_DAYS: 'scheduledDays',
    SCHEDULES: 'schedules',
    SPEED_PROFILES: 'speedProfiles',
    STYLE: 'style'
})
